<template>
  <div class="main">

    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" size="small" class="chaxun">查询列表</Button
        ><Button @click="openAdd" type="primary" size="small" class="chaxun"
          >新增派工</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-row-click="$emit('obj', $event)"
    >
      <template slot-scope="{ row, index }" slot="liucheng">
        <Button
          v-if="row.flowStartId == null"
          size="small"
          @click="addFlow(row)"
          >重新发起</Button
        >
        <span v-else>已发起</span>
      </template>
      <viewer slot-scope="{ row, index }" :slot="'approveFileList'">
        <img
          v-for="(y, index1) in row.approveFileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
      <viewer slot-scope="{ row, index }" :slot="'handoverFileList'">
        <img
          v-for="(y, index1) in row.handoverFileList"
          :key="index1"
          :src="axios.platConfig.fileUri + y"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
      <template slot-scope="{ row, index }" slot="action">
        <Button @click="detail(row)" size="small" v-if="false">详情</Button>
        <Button size="small" @click="openJincheng(row)">查看进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model title="新增派工" width="700" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <createdFlow ref="createdFlow" @ok='getList'></createdFlow>
    <docDetail v-if="false" ref="docDetail"></docDetail>
    <jincheng ref="jincheng"></jincheng>
  </div>
</template>
<script>
import fields from "../yhgl/forms/fields";
import createdFlow from "../yhgl/forms/createdFlow.vue";
import docDetail from "../yhgl/docDetail.vue";
import jincheng from "../yhgl/jincheng.vue";
export default {
  components: { createdFlow, docDetail, jincheng },
  data() {
    return {
      isAdd: false,
      columns: [
        { type: "index" },
        { title: "工单号", key: "no",sort:0.1, maxWidth: 300, minWidth: 100 },
        {
          title: "流程状态",
          slot: "liucheng",
          sort: 29,
          maxWidth: 300,
          minWidth: 100,
          fixed:'right'
        },
        {
          title: "操作",
          slot: "action",
          sort: 30,
          maxWidth: 300,
          minWidth: 100,
          fixed:'right'
        },
      ],
      tableData: [],
      item: {
        groupName: "",
        groupId: "",
        pileNo: ["全线快车道"],
        dept: "珠海市公路事务中心",
        time: Date.now(),
        address: "横琴二桥",
        supervisor: "",
        dispatcher: "",
        itemList:[],
        name:''
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: fields.gaoweizuoye,
      formId: "7",
      flowId: "1620714615765766145",
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-dpm/apply/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].time2 = this.utils.time(data[i].time, "yymmdd");
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-rmm-server-dpm/apply/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            var data = res.data.data;
            this.addFlow(data);
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.dm + "/carType/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/carType/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    addFlow(data) {
      var obj = {
        flowId: this.flowId,
        id: data.id,
        no: data.no,
        groupId: data.groupId,
        formId: this.formId,
        workerLeader: data.workerLeader,
        workerId: data.workerId,
      };
      this.$refs.createdFlow.reach(obj);
    },
    detail(row) {
      var obj = {
        formId: this.formId,
        docId: row.id,
      };
      this.$refs.docDetail.reach(obj);
    },
    openJincheng(row) {
      var obj = {
        flowStartId: row.flowStartId,
        flowId: row.flowId,
      };
      this.$refs.jincheng.reach(obj);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.getList();
    },
    getUser() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.item.dispatcher = this.utils.text(data.name, "");
      });
    },
  },
  mounted() {
    var config = { min: 130, max: 240 };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.chaxun();
    this.getUser();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/zuoyepaigong/gaoweishenqingList.vue